import { render, staticRenderFns } from "./ConstructionInfo.vue?vue&type=template&id=3d5866fb&"
import script from "./ConstructionInfo.vue?vue&type=script&lang=ts&"
export * from "./ConstructionInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports